module.exports = __webpack_public_path__ + "assets1752042029796/img/home-img.ff28be9e.jpg";